import Navbar from "@/components/origin/Navbar";
import Hero from "@/components/origin/Hero";
import DiscordWidget from "@/components/origin/DiscordWidget";
import WhatsAppWidget from "@/components/origin/WhatsAppWidget";
import Features from "@/components/origin/Features";
import HowToPlay from "@/components/origin/HowToPlay";
import Stats from "@/components/origin/Stats";
import Footer from "@/components/origin/Footer";
import ChatWidget from "@/components/origin/ChatWidget";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen bg-[#030305] text-slate-100 overflow-hidden"
    >
      {/* Global background grid + noise */}
      <div className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div className="noise-overlay" />
      </div>

      <div className="relative z-10">
        <Navbar />
        <Hero />
        <DiscordWidget />
        <WhatsAppWidget />
        <Features />
        <HowToPlay />
        <Stats />
        <Footer />
        <ChatWidget />
      </div>
    </main>
  );
}
